// --------------------------------------------------------------------------
// buttons.js
// --------------------------------------------------------------------------
// Adds an extra span so we can do some nice hover styles
// --------------------------------------------------------------------------

EC.buttons = function () {

    'use strict';

    function init () {
        const buttons = [].slice.call(document.getElementsByClassName('e-button'));
        const wysiwygButtons = [].slice.call(document.querySelectorAll('.b-wysiwyg__button-row a'));
        const wysiwygButtonsCenter = [].slice.call(document.querySelectorAll('.b-wysiwyg__button-row--centered a'));
        buttons.map(convertButton);
        wysiwygButtons.map(convertButton);
        wysiwygButtonsCenter.map(convertButton);
    }

    function convertButton(button){
        button.classList.add('e-button--has-bubble');
        button.innerHTML = spanWrap(button);
    }

    function spanWrap(button){
        return `<span class="e-button__label">${button.textContent}</span>`;
    }

    return {
        init: init
    };

}();